import * as React from "react";
import { CorrectionItemPreviewProps, CorrectionItemPreview } from "../WizardTypings";
import { CorrectionBreakdownItem } from "../../CorrectionBreakdownItem";
import { Correction } from "../../../Request/DcfRequestReducer";

const PreviewSelector = (corrections: Correction[]): boolean => corrections.length > 0 && corrections[0].entity == "Session" && corrections[0].field == "IsSuppressed";

const SuppressSessionPreviewItem = ({ corrections }: CorrectionItemPreviewProps): JSX.Element => {
    if (!(PreviewSelector(corrections))) {
        return null;
    }

    return <CorrectionBreakdownItem key={`BreakdownItem${name}`} fieldName={corrections[0].field} from={corrections[0].oldValue} to={corrections[0].newValue} />;
};

const SuppressSessionPreview: CorrectionItemPreview = {
    previewElement: SuppressSessionPreviewItem,
    previewSelector: PreviewSelector
};

export default SuppressSessionPreview;
